

















import {Component, Prop, Vue} from "vue-property-decorator";
import {SiteEntity} from "@/entity/SiteEntity";

/*
 * Sitenin Seo::seoUrl() kuralının aynısı. Site sayfayı bu adrese 301 ile
 * yönlendirdiği için önizleme ziyaretçinin gerçekte göreceği adresi göstersin
 * (eski helper.seoUrl büyük harf ve Türkçe karakterleri olduğu gibi bırakıyordu).
 */
const SLUG_FROM = ['ş','Ş','ı','I','İ','ğ','Ğ','ü','Ü','ö','Ö','Ç','ç','(',')','/',':',',',
    'â','Â','î','Î','û','Û','é','É','è','ê','ë','á','à','ä','ï','ó','ò','ô','ú','ù','ñ','ß'];
const SLUG_TO = ['s','s','i','i','i','g','g','u','u','o','o','c','c','','','-','-','',
    'a','a','i','i','u','u','e','e','e','e','e','a','a','a','i','o','o','o','u','u','n','ss'];

function siteSlug(text: any): string {
    let s = String(text === undefined || text === null ? "" : text);
    SLUG_FROM.forEach((from: string, i: number) => {
        s = s.split(from).join(SLUG_TO[i]);
    });
    // PHP strtolower ve \s yalnızca ASCII'ye dokunur; kalan her şey aşağıda atılır
    s = s.replace(/[A-Z]/g, (c: string) => c.toLowerCase());
    s = s.replace(/[ \t\n\r\f\v]+/g, "-");
    s = s.replace(/-+/g, "-");
    s = s.replace(/#/g, "");
    s = s.replace(/[*'"`’]/g, "-");
    s = s.replace(/[.&]/g, "");
    s = s.replace(/[^a-z0-9-]+/g, "");
    s = s.replace(/-+/g, "-");
    return s.replace(/^-+|-+$/g, "");
}

/** Taban adrese yol ekler; yereldeki "...?site=x" tabanında sorgu sona kalır */
function joinUrl(base: string, path: string): string {
    if (!base) {
        return "";
    }
    const q = base.indexOf("?");
    return q === -1 ? base + path : base.substring(0, q) + path + base.substring(q);
}

@Component({})
export default class SeoText extends Vue {
    @Prop({default:true}) required!:boolean;
    @Prop({}) value!:string;
    @Prop({default:"12"}) md!:string;
    @Prop({default:""}) pattern!:string;
    @Prop({default:false}) disabled!:boolean;
    @Prop({default:""}) extPattern!:string;
    rules:any = [];

    get activeSite(): SiteEntity | null {
        return this.$store.getters.activeSite;
    }

    /*
     * Önizleme AKTİF şubenin canlı alan adıyla gösterilir. Eskiden API
     * adresi (hep Güzelbahçe) kullanılıyordu; Buca seçiliyken de
     * brainfitguzelbahce.com.tr görünüyordu. Şube listesi henüz yoksa eski
     * davranışa düşülür.
     */
    get publicBase(): string {
        return this.$store.getters.publicSiteUrlFor(this.activeSite) || this.$store.getters.activeSiteUrl || "";
    }

    /** Göz simgesinin açtığı adres: yerelde yerel şube adresi (canlıda henüz olmayan sayfa da denenebilsin) */
    get openBase(): string {
        return this.$store.getters.siteUrlFor(this.activeSite) || this.publicBase;
    }

    get path(): string {
        return this.pattern + siteSlug(this.value) + this.extPattern;
    }

    get previewUrl(): string {
        return joinUrl(this.publicBase, this.path);
    }

    get openUrl(): string {
        return joinUrl(this.openBase, this.path);
    }

    get localHint(): string {
        if (!this.$store.getters.isLocalMode || this.openUrl === "" || this.openUrl === this.previewUrl) {
            return "";
        }
        return "Yerel ortam: göz simgesi " + this.openUrl + " adresini açar.";
    }

    /** Eski kullanım için korunur */
    createUrl(){
        return this.previewUrl;
    }
    updateValue (value:string) {
        this.$emit('input', value)
    }
    goUrl(){
        if (this.openUrl !== "") {
            window.open(this.openUrl, "_blank", "noopener");
        }
    }
    created(){
        if(this.required === true){
            this.rules.push((v: any) => !!v || 'Zorunlu.');
        }
    }

}
